import React from 'react';
import './index.css';
import { Button, Image } from 'react-bootstrap';
import { BsCheckLg } from 'react-icons/bs';

const HeroSection = () => {

  return (
    <div className='hero-section'>
      <div className='container h-100'>
        <div className='row h-100'>
          <div className='col-xl-6 col-lg-12 col-md-12 col-12'>
            <div className='h-100 d-flex flex-column text-xl-start text-center justify-content-center'>
              <h1 className='fw-normal'>
                <span>All-in-One</span>
                <br />
                <span className='fw-bold'>Real Estate CRM</span>
              </h1>
              <h2>Smarter, Faster, & More Profitable</h2>
              <p className='mt-4'>Seamlessly manage leads, automate bookings with flexible installment plans, and gain complete financial control—all in one powerful platform.</p>
              <ul className='d-xl-block d-none'>
                <li>
                  <BsCheckLg size={16} />
                  <span className='ms-2'><span className='fw-600'>Smart Lead Management</span> - Capture, nurture, and convert leads effortlessly.</span>
                </li>
                <li>
                  <BsCheckLg size={16} />
                  <span className='ms-2'><span className='fw-600'>Flexible Bookings & Installments</span> - Hassle-free payment scheduling for customers.</span>
                </li>
                <li>
                  <BsCheckLg size={16} />
                  <span className='ms-2'><span className='fw-600'>Financial Reports & Insights</span> - Real-time analytics to grow your business.</span>
                </li>
              </ul>
              <div className='d-flex align-items-center justify-content-xl-start justify-content-center mt-3'>
                <Button
                  variant='primary'
                  className='me-2 rounded'
                >
                  Get Started Today
                </Button>
                <Button
                  variant='outline-dark'
                  className='ms-2 rounded'
                >
                  Book a Free Demo
                </Button>
              </div>
            </div>
          </div>
          <div className='col-xl-6 col-lg-12 col-md-12 col-12'>
            <div className='hero-image'>
              <Image src='../images/hero/hero-img.png' />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroSection;
